module.exports = __webpack_public_path__ + "img/caatinga.e960901a.png";